<template>
  <div id="contenedor-componente-main-menu">
    <v-navigation-drawer
      v-model="mostrar"
      :mini-variant="$vuetify.breakpoint.lgAndUp ? mini : false"
      :expand-on-hover="$vuetify.breakpoint.lgAndUp && mini"
      app
      dark
      color="#05053e"
      width="280"
      class="menu-drawer elevation-4"
    >
      <!-- Logo y toggle -->
      <div class="logo-header d-flex align-center px-3 py-4">
        <div class="logo-wrapper">
          <v-img
            contain
            src="@/assets/sideop-png.png"
            max-height="32"
            max-width="140"
            class="logo-full"
          />
          <v-img
            contain
            src="@/assets/icon-color.png"
            max-height="28"
            max-width="28"
            class="logo-mini"
          />
        </div>
        <v-spacer />
        <v-btn
          v-if="$vuetify.breakpoint.lgAndUp"
          icon
          small
          class="toggle-btn"
          @click="mini = !mini"
        >
          <v-icon small color="base7">
            {{ mini ? 'mdi-chevron-right' : 'mdi-chevron-left' }}
          </v-icon>
        </v-btn>
      </div>

      <!-- Contenido del menú con scroll -->
      <div class="menu-content">
        <div
          v-for="(seccion, idx) in menuFiltrado"
          :key="'section-' + idx"
        >
          <!-- Header de sección -->
          <v-subheader
            v-if="!mini || !$vuetify.breakpoint.lgAndUp"
            class="section-header text-overline font-weight-medium px-4"
            :class="{ 'mt-3': idx > 0 }"
          >
            {{ seccion.seccion }}
          </v-subheader>
          <v-divider
            v-else-if="idx > 0"
            class="my-3 mx-4 divider-mini"
          />

          <!-- Items de la sección -->
          <v-list
            dense
            nav
            class="py-0 px-2"
          >
            <template v-for="item in seccion.items">
              <!-- Item sin hijos -->
              <v-list-item
                v-if="!item.children || item.children.length === 0"
                :key="item.ruta"
                :to="{ name: item.ruta }"
                :disabled="usuarioTieneScopes(item.scopes)"
                link
                class="menu-item rounded-lg mb-1"
                active-class="menu-item-active"
              >
                <v-list-item-icon class="mr-3 my-auto">
                  <v-icon size="20">{{ item.icono }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title class="text-body-2 font-weight-regular">
                    {{ item.nombre }}
                  </v-list-item-title>
                </v-list-item-content>
                <!-- Badge para observaciones si aplica -->
                <v-list-item-action
                  v-if="item.ruta === 'ejecucion' && contadorObservaciones"
                  class="pa-0 ma-0"
                >
                  <v-badge
                    inline
                    color="naranja"
                    :content="contadorObservaciones"
                  />
                </v-list-item-action>
              </v-list-item>

              <!-- Item con hijos (expandible) -->
              <v-list-group
                v-else
                :key="item.ruta + '-group'"
                :prepend-icon="item.icono"
                no-action
                class="menu-group"
              >
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title class="text-body-2 font-weight-regular">
                      {{ item.nombre }}
                    </v-list-item-title>
                  </v-list-item-content>
                </template>

                <v-list-item
                  v-for="child in item.children"
                  :key="child.ruta"
                  :to="{ name: child.ruta }"
                  :disabled="usuarioTieneScopes(child.scopes)"
                  link
                  class="menu-item-child rounded-lg ml-6 mr-1 mb-1"
                  active-class="menu-item-active"
                >
                  <v-list-item-icon class="mr-3 my-auto">
                    <v-icon size="16">{{ child.icono }}</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title class="text-body-2 font-weight-regular">
                      {{ child.nombre }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-group>
            </template>
          </v-list>
        </div>
      </div>

      <!-- Footer con logout -->
      <template v-slot:append>
        <div class="logout-section pa-3">
          <v-divider class="mb-3 divider-accent" />
          <v-list-item
            class="menu-logout rounded-lg"
            :to="{ name: 'logout' }"
          >
            <v-list-item-icon class="mr-3 my-auto">
              <v-icon size="20" color="error">mdi-logout</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="text-body-2 error--text">
                Cerrar Sesión
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </div>
      </template>
    </v-navigation-drawer>
  </div>
</template>

<script>
import menu from '@/components/main-menu/menu';
import GET_CONTRATOS_CON_OBSERVACIONES
from '@/graphql/querys/administracion/auditorias/getNumberContratosWithObservacionesActivas.gql';
import eventBus from '@/helpers/eventBus';

export default {
  name: 'componenteMainMenu',
  data() {
    return {
      mostrar: true,
      mini: false,
    };
  },
  apollo: {
    getNumberContratosWithObservacionesActivas: {
      query: GET_CONTRATOS_CON_OBSERVACIONES,
    },
  },
  computed: {
    menuFiltrado() {
      return menu;
    },
    getScopes() {
      if (!this.$auth.user) { return ['']; }
      return this.$auth.user.scopes;
    },
    contadorObservaciones() {
      return this.getNumberContratosWithObservacionesActivas || null;
    },
  },
  mounted() {
    eventBus.$on('mostrar-ocultar-menu', () => {
      this.mostrarOcultarMenu();
    });
  },
  methods: {
    mostrarOcultarMenu() {
      this.mostrar = !this.mostrar;
    },
    usuarioTieneScopes(rutaScopes) {
      if (rutaScopes === '') { return false; }
      if (Array.isArray(this.getScopes)) {
        if (!this.getScopes.includes(rutaScopes)) { return true; }
      }
      return false;
    },
  },
};
</script>

<style lang="scss">
// Colores del sistema
$primary: #05053e;
$secondary: #1B1BAF;
$base1: #4edadd;
$base7: #a3a3da;
$base4: #D6D6EE;

// Estilos encapsulados por #contenedor-componente-main-menu
#contenedor-componente-main-menu {
  .menu-drawer {
    background: linear-gradient(180deg, $primary 0%, darken($primary, 3%) 100%);
    border-right: none !important;
  }

  .logo-header {
    background: rgba(0, 0, 0, 0.15);
    border-bottom: 1px solid rgba(255, 255, 255, 0.06);
    min-height: 56px;
  }

  .logo-wrapper {
    position: relative;
    display: flex;
    align-items: center;
    min-width: 28px;
    height: 32px;
  }

  .logo-full {
    transition: opacity 0.2s ease;
  }

  .logo-mini {
    position: absolute;
    left: 0;
    opacity: 0;
    transition: opacity 0.2s ease;
  }

  // Estado mini sin hover: mostrar icono
  .v-navigation-drawer--mini-variant:not(.v-navigation-drawer--is-mouseover) {
    .logo-full {
      opacity: 0;
    }
    .logo-mini {
      opacity: 1;
    }
  }

  // Estado mini con hover: mostrar logo completo
  .v-navigation-drawer--mini-variant.v-navigation-drawer--is-mouseover {
    .logo-full {
      opacity: 1;
    }
    .logo-mini {
      opacity: 0;
    }
  }

  .toggle-btn {
    background: rgba(255, 255, 255, 0.05);
    transition: all 0.2s ease;

    &:hover {
      background: rgba(255, 255, 255, 0.12);
    }
  }

  .divider-accent {
    border-color: rgba(255, 255, 255, 0.08) !important;
    margin: 0;
  }

  .divider-mini {
    border-color: rgba(255, 255, 255, 0.1) !important;
  }

  .section-header {
    color: $base7 !important;
    letter-spacing: 0.08em;
    font-size: 0.68rem !important;
    height: 32px;
    min-height: 32px;
  }

  .menu-content {
    overflow-y: auto;
    overflow-x: hidden;
    height: calc(100vh - 180px);
    padding-bottom: 8px;

    &::-webkit-scrollbar {
      width: 3px;
    }

    &::-webkit-scrollbar-track {
      background: transparent;
    }

    &::-webkit-scrollbar-thumb {
      background: rgba(255, 255, 255, 0.08);
      border-radius: 3px;
    }

    &::-webkit-scrollbar-thumb:hover {
      background: rgba(255, 255, 255, 0.15);
    }
  }

  .menu-item {
    min-height: 40px;
    padding: 0 12px;
    transition: all 0.15s ease;
    color: rgba(255, 255, 255, 0.85);

    .v-icon {
      color: $base7 !important;
      transition: color 0.15s ease;
    }

    &:hover {
      background: rgba(255, 255, 255, 0.06) !important;

      .v-icon {
        color: $base1 !important;
      }
    }
  }

  .menu-item-active {
    background: linear-gradient(
      90deg,
      rgba($secondary, 0.4) 0%,
      rgba($secondary, 0.15) 100%
    ) !important;
    border-left: 3px solid $base1;
    color: white !important;

    .v-icon {
      color: $base1 !important;
    }

    .v-list-item__title {
      font-weight: 500 !important;
    }
  }

  .menu-item-child {
    min-height: 36px;
    padding: 0 10px;
    transition: all 0.15s ease;
    color: rgba(255, 255, 255, 0.75);

    .v-icon {
      color: rgba($base7, 0.7) !important;
    }

    &:hover {
      background: rgba(255, 255, 255, 0.05) !important;
      color: rgba(255, 255, 255, 0.95);

      .v-icon {
        color: $base1 !important;
      }
    }
  }

  .menu-group {
    margin-bottom: 2px;

    .v-list-group__header {
      min-height: 40px;
      padding: 0 12px;
      border-radius: 8px;
      color: rgba(255, 255, 255, 0.85);
      transition: all 0.15s ease;

      .v-icon {
        color: $base7 !important;
      }

      &:hover {
        background: rgba(255, 255, 255, 0.06) !important;

        .v-icon {
          color: $base1 !important;
        }
      }
    }

    .v-list-group__items {
      background: rgba(0, 0, 0, 0.12);
      border-radius: 0 0 8px 8px;
      margin-top: 2px;
      padding: 4px 0;
    }
  }

  .logout-section {
    background: rgba(0, 0, 0, 0.1);
  }

  .menu-logout {
    min-height: 40px;
    padding: 0 12px;
    transition: all 0.15s ease;
    background: rgba(244, 67, 54, 0.08);

    &:hover {
      background: rgba(244, 67, 54, 0.18) !important;
    }
  }
}
</style>
